import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { GatheringSpot } from '@outdoria/types';
import { fetcher } from '../utils';
import { ADMIN_GATHERING_SPOT_CREATE, GATHERING_SPOTS_ALL } from '../queryKeys';

export const useAdminCreateGatheringSpot = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (
    gathering_spot: Omit<GatheringSpot, 'gathering_spot_id'>,
  ): Promise<void> => {
    const response = await fetcher(`/v2/admin/gathering_spots`, {
      method: 'POST',
      body: JSON.stringify(gathering_spot),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (response.status !== 201)
      throw new Error((await response.json()).error ?? 'Did not work!');
    queryClient.invalidateQueries({ queryKey: GATHERING_SPOTS_ALL });
  };

  const { mutate, error, status, isPending, isSuccess, isError } = useMutation({
    mutationKey: ADMIN_GATHERING_SPOT_CREATE,
    mutationFn,
  });

  return { mutate, error, status, isPending, isSuccess, isError };
};
